import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_pdf_kal_fonts_bn'

const hubToRtmPdfDetails = async (base64Logo, vm, hubName) => {
  try {
    Store.commit('mutateCommonProperties', {
      loading: true
    })

    pdfMake.vfs = pdfFontsBn.pdfMake.vfs 
    pdfMake.fonts = {
      Kalpurush: {
        normal: 'Kalpurush.ttf',
        bold: 'Kalpurush.ttf',
        italics: 'Kalpurush.ttf',
        bolditalics: 'Kalpurush.ttf'
      }
    }
    
    const pdfContent = [
      { image: 'data:image/png;base64,' + base64Logo, height: 70, width: 70, style: 'logo', alignment: 'left' },
      { text: 'Hub: '+ hubName +', Total Order : ' + vm.length, style: 'org', alignment: 'left' }
    ]

    pdfContent.push({ text: '', style: 'space' })

    const allRows = [
      [
        { text: 'Order ID', style: 'th', alignment: 'center', bold: true },
        { text: 'Date', style: 'th', alignment: 'center', bold: true },
        { text: 'Customer', style: 'th', alignment: 'center', bold: true },
        { text: 'Address', style: 'th', alignment: 'center', bold: true },
        { text: 'Price', style: 'th', alignment: 'center', bold: true },
        { text: 'Status', style: 'th', alignment: 'center', bold: true },
        { text: 'Reason', style: 'th', alignment: 'center', bold: true }
      ]
    ]

    vm.forEach(item => {
        const orderStatus = getOrderStatus(item.status)
        allRows.push([
            { text: item.id, alignment: 'center', style: 'td' },
            { text: item.date, alignment: 'center', style: 'td' },
            { text: item.name + ', '+ item.mobile, alignment: 'center', style: 'td' },
            { text: item.address, alignment: 'center', style: 'td' },
            { text: item.price, alignment: 'center', style: 'td' },
            { text: orderStatus, alignment: 'center', style: 'td', color: getStatusColor(item.status) },
            { text: item.reason, alignment: 'center', style: 'td' }
        ])
    })

    pdfContent.push({
        table: {
            headerRows: 1,
            widths: '*',
            body: allRows
        }
    })

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      footer: function (currentPage, pageCount) {
        return {
          table: {
            body: [
                [
                  { text: "Page " + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', /*margin: [0, 0, 0, 0]*/ }
                ]
            ]
          }
        };
      },
      defaultStyle: {
        font: 'Kalpurush'
      },
      styles: {
        th: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        td: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        space: {
          margin: [5, 0, 0, 5]
        },
        header: {
          fontSize: 17,
          bold: true,
          margin: [0, 5, 0, 0]
        },
        logo: {
          margin: [0, 0, 0, 10]
        },
        normalText: {
          border: 0
        },
        hh: {
          fontSize: 13,
          bold: true,
          margin: [10, 10, 25, 20]
        }
      }
    }
    var win = window.open('', '_blank')
    pdfMake.createPdf(docDefinition).open({}, win)
  } catch (error) {
    if (error) {
      console.log('err => ', error)
    }
  }
  Store.commit('mutateCommonProperties', {
    loading: false
  })
}

function getOrderStatus (status) {
    const tmpStatus = Store.state.statusList.find(el => el.id == status)
    return tmpStatus.text
  }

function getStatusColor (status) {
    if (status == 15) {
        return [0, 255, 128]
    } else if (status == 19) {
        return [65, 94, 82]
    } else if (status == 20) {
        return [222, 11, 11]
    }
  }

export default {
    hubToRtmPdfDetails
}
